export var CompanyType;
(function (CompanyType) {
    CompanyType[CompanyType["Site"] = 2] = "Site";
    CompanyType[CompanyType["Company"] = 1] = "Company";
    CompanyType[CompanyType["Group"] = 0] = "Group";
})(CompanyType || (CompanyType = {}));
